import React from 'react';
import ReactDOM from 'react-dom/client';
import type { ProviderProfileProps } from '~/types/Provider';
import { ProviderProfile } from '~/pages/Provider/Profile/ProviderProfile';

import '~/styles/main.scss';

interface WindowWithData extends Window {
  data: ProviderProfileProps;
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const data = (window as unknown as WindowWithData).data || {};

root.render(
  <React.StrictMode>
    <ProviderProfile {...data} />
  </React.StrictMode>
);
